import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api/axios";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../../css/User/Supportpage.css";
import { getSidebarMenus } from "../../constants/sidebarMenus";
import { logout, getCurrentUserId } from "../../utils/auth";
import TopHeader from "../../components/comman/TopHeader";
import Sidebar from "../../components/comman/Sidebar";
import { toast } from "react-toastify";
const currentUserId = getCurrentUserId();

const faqs = [
  {
    question: "What is the maximum video length I can upload?",
    answer: "You can upload videos up to 10 minutes in length.",
  },
  {
    question: "What payment methods do you support?",
    answer: "We support UPI, Credit/Debit Cards, Net Banking, and Wallets.",
  },
  {
    question: "How do I hide my posts from specific users?",
    answer: "Go to post settings and select users you want to hide your post from.",
  },
  {
    question: "How do I create a group or community?",
    answer: "Navigate to the Groups section and click on Create Group.",
  },
];

const Button = ({ text, onClick, loading, disabled = false, type = "button", className = "" }) => {
  return (
    <button
      type={type}
      className={`rounded-pill py-2 ${className}`}
      onClick={onClick}
      disabled={loading || disabled}
    >
      {loading ? "Please wait..." : text}
    </button>
  );
};

const Supportpage = () => {
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(true);
  const [activeSidebar, setActiveSidebar] = useState("support");
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const sidebarMenus = getSidebarMenus(currentUserId);
  const { type } = useParams();
  const [feedType, setFeedType] = useState(type === "public" ? "public" : "prime");

  useEffect(() => {
    if (type === "public" || type === "prime") setFeedType(type);
  }, [type]);

  const [showChatBot, setShowChatBot] = useState(false);
  const [chatMessages, setChatMessages] = useState([{ sender: "bot", text: "Hi 👋 How can I help you today?" }]);
  const [chatInput, setChatInput] = useState("");
  const chatEndRef = useRef(null);
  const [botTyping, setBotTyping] = useState(false);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatMessages]);

  const handleSendMessage = async () => {
    if (!chatInput.trim()) return;
    const userMessage = { sender: "user", text: chatInput };
    setChatMessages((prev) => [...prev, userMessage]);
    setChatInput("");
    setTimeout(() => {
      const botReply = { sender: "bot", text: getAIResponse(chatInput) };
      setChatMessages((prev) => [...prev, botReply]);
    }, 800);
  };

  const getAIResponse = (message) => {
    const msg = message.toLowerCase();
    if (msg.includes("payment")) return "We support UPI, Cards, and Net Banking.";
    if (msg.includes("video")) return "Maximum video upload length is 10 minutes.";
    if (msg.includes("hello")) return "Hello 👋 How can I assist you?";
    if (msg.includes("help")) return "Sure! Tell me what you need help with.";
    return "Thanks for your message! Our team will assist you shortly 🤝";
  };

  const [showAdminContactModal, setShowAdminContactModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState({});
  const [openDropdown, setOpenDropdown] = useState(null);

  const [formData, setFormData] = useState({
    phone: "",
    description: "",
    time: "Morning (9 AM-12 PM)",
    language: "Hindi",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }
    if (!formData.description.trim()) {
      newErrors.description = "description description is required";
    } else if (formData.description.trim().length < 10) {
      newErrors.description = "description description must be at least 10 characters";
    } else if (formData.description.trim().length > 500) {
      newErrors.description = "description description cannot exceed 500 characters";
    }
    if (!formData.time) newErrors.time = "Please select best time to call";
    if (!formData.language) newErrors.language = "Please select a language";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    try {
      setLoading(true);
      const res = await api.post("/support-requests", formData);
      if (!res) throw new Error("Something went wrong");
      setSuccess(true);
      setFormData({ phone: "", description: "", time: "Morning (9 AM-12 PM)", language: "Hindi" });
      setTimeout(() => {
        setShowAdminContactModal(false);
        setSuccess(false);
      }, 2000);
    } catch (err) {
      toast.error("You already have a pending support request");
    } finally {
      setLoading(false);
    }
  };

  const [activeIndex, setActiveIndex] = useState(null);
  const toggleFAQ = (index) => setActiveIndex(activeIndex === index ? null : index);

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />
        <div className="prime-layout-container .container-fluid">
          <div className="row">
            {!showSidebar && (
              <div className="left-sidebar-overlay d-md-none" onClick={() => setShowSidebar(true)} />
            )}
            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              feedType={feedType}
              onNavigate={(item) => navigate(item.path)}
              onLogout={handleLogout}
            />

            <div className="col-12 col-md-9 overflow-auto center-area-container">
              <div className="support-chat-center-area">
                <div className="support-wrapper">
                  <div className="support-hero">
                    <div className="w-100 d-flex align-items-center justify-content-start text-start">
                      <h5 className="mb-0 fw-bold">Support Chat</h5>
                    </div>
                    <p className="w-100 text-start">
                      Our support chat is here to provide quick, reliable assistance whenever you need help.
                    </p>

                    <div className="help-card-container">
                      <div className="help-card">
                        <div className="w-100 d-flex align-items-center gap-3">
                          <div className="w-100">
                            <div className="support-card-text d-flex justify-content-between align-items-center">
                              <div className="support_chat_icons">
                                <div className="d-flex gap-2">
                                  <span className="help-icon">?</span>
                                  <h6 className="mb-0">Get Help</h6>
                                </div>
                                <h5 className="support-chat-arrow mb-1">›</h5>
                              </div>
                            </div>
                            <h6 className="text-secondary mt-2">We're always happy to help..</h6>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-2 mb-2 px-sm-2 g-2">
                        <div className="col-12 col-sm-6">
                          <Button text="Admin Contact" className="admin-contact-button" onClick={() => setShowAdminContactModal(true)} />
                        </div>
                        <div className="col-12 col-sm-6">
                          <Button text="Start Conversation" className="support-chat-button" onClick={() => setShowChatBot(true)} />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* FAQ Section */}
                  <div className="faq-section container">
                    <h6 className="faq-title text-center">Frequently Asked Questions</h6>
                    {faqs.map((faq, index) => (
                      <div
                        className={`faq-item accordion accordion-flush ${activeIndex === index ? "active" : ""}`}
                        key={index}
                        onClick={() => toggleFAQ(index)}
                        id={`accordion-${index}`}
                      >
                        <div className="accordion-item">
                          <h2 className="accordion-header" id={`heading-${index}`}>
                            <button
                              className="accordion-button collapsed faq-question"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse-${index}`}
                              aria-expanded="false"
                              aria-controls={`collapse-${index}`}
                            >
                              {faq.question}
                            </button>
                          </h2>
                          <div
                            id={`collapse-${index}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`heading-${index}`}
                            data-bs-parent={`#accordion-${index}`}
                          >
                            <div className="accordion-body faq-answer">{faq.answer}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CHATBOT DRAWER */}
      {showChatBot && (
        <>
          <div className="chatbot-overlay" onClick={() => setShowChatBot(false)} />
          <div className="chatbot-drawer">
            <div className="chatbot-header">
              <h5 className="mb-0">Support Assistant</h5>
              <span onClick={() => setShowChatBot(false)}>✕</span>
            </div>
            <div className="chatbot-body">
              {chatMessages.map((msg, index) => (
                <div key={index} className="w-100">
                  <div className={`chat-message ${msg.sender}`}>
                    <p>{msg.text}</p>
                  </div>
                </div>
              ))}
              {botTyping && <div className="chat-message bot typing"><p>Typing...</p></div>}
              <div ref={chatEndRef} />
            </div>
            <div className="chatbot-input">
              <input
                type="text"
                placeholder="Type your message..."
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
              />
              <button onClick={handleSendMessage}>Send</button>
            </div>
          </div>
        </>
      )}

      {/* ===== ADMIN CONTACT MODAL ===== */}
      {showAdminContactModal && (
        <div className="modal fade show support-modal-backdrop" style={{ display: "block" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content admin-contact-modal">

              {/* Header */}
              <div className="admin-modal-header">
                <button
                  className="admin-modal-back"
                  onClick={() => setShowAdminContactModal(false)}
                >
                  ←
                </button>
                <h5 className="mb-0">Contact Admin</h5>
                <div style={{ width: 32 }} />
              </div>

              {/* Body */}
              <div className="admin-modal-body">
                {success ? (
                  <div className="success-box text-center py-5">
                    <div className="checkmark">✓</div>
                    <h6>Request Submitted!</h6>
                    <p>Our support team will contact you soon.</p>
                  </div>
                ) : (
                  <>
                    {/* PHONE */}
                    <p className="admin-field-label">Enter Mobile Number</p>
                    <div className={`admin-phone-input ${errors.phone ? "input-error" : ""}`}>
                      <span className="phone-prefix">
                        +91 &nbsp;
                        <img
                          src="https://flagcdn.com/w20/in.png"
                          alt="India"
                          style={{ width: "20px", height: "14px", objectFit: "cover", borderRadius: "2px", verticalAlign: "middle" }}
                        />
                        &nbsp;|
                      </span>
                      <input
                        type="tel"
                        name="phone"
                        maxLength={10}
                        placeholder="Enter your mobile number"
                        value={formData.phone}
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D/g, "");
                          setFormData({ ...formData, phone: val });
                          setErrors({ ...errors, phone: "" });
                        }}
                      />
                    </div>
                    {errors.phone && <p className="admin-error">{errors.phone}</p>}

                    {/* REASON */}
                    <p className="admin-field-label mt-3">Reason for Contact*</p>
                    <div className={`admin-textarea-wrapper ${errors.description ? "input-error" : ""}`}>
                      <textarea
                        name="description"
                        rows="5"
                        placeholder="Enter your message"
                        maxLength={500}
                        value={formData.description}
                        onChange={handleChange}
                      />
                      <span className="char-counter">{formData.description.length}/500</span>
                    </div>
                    {errors.description && <p className="admin-error">{errors.description}</p>}

                    {/* BEST TIME TO CALL - Custom Dropdown */}
                    <p className="admin-field-label mt-3">Best Time to Call*</p>
                    <div className="custom-dropdown-wrapper">
                      <div
                        className={`custom-dropdown-trigger ${errors.bestTime ? "input-error" : ""}`}
                        onClick={() => setOpenDropdown(openDropdown === "bestTime" ? null : "bestTime")}
                      >
                        <span>{formData.bestTime}</span>
                        <span className="custom-dropdown-arrow">{openDropdown === "bestTime" ? "▲" : "▼"}</span>
                      </div>
                      {openDropdown === "bestTime" && (
                        <div className="custom-dropdown-list">
                          {["Morning (9 AM-12 PM)", "Afternoon (12 PM-4 PM)", "Evening (4 PM-7 PM)"].map((option) => (
                            <div
                              key={option}
                              className={`custom-dropdown-option ${formData.bestTime === option ? "selected" : ""}`}
                              onClick={() => {
                                setFormData({ ...formData, bestTime: option });
                                setErrors({ ...errors, bestTime: "" });
                                setOpenDropdown(null);
                              }}
                            >
                              {option}
                              {formData.bestTime === option && <span className="custom-check">✓</span>}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {errors.bestTime && <p className="admin-error">{errors.bestTime}</p>}

                    {/* LANGUAGE - Custom Dropdown */}
                    <p className="admin-field-label mt-3">Language</p>
                    <div className="custom-dropdown-wrapper">
                      <div
                        className={`custom-dropdown-trigger ${errors.language ? "input-error" : ""}`}
                        onClick={() => setOpenDropdown(openDropdown === "language" ? null : "language")}
                      >
                        <span>{formData.language}</span>
                        <span className="custom-dropdown-arrow">{openDropdown === "language" ? "▲" : "▼"}</span>
                      </div>
                      {openDropdown === "language" && (
                        <div className="custom-dropdown-list">
                          {["Hindi", "English"].map((option) => (
                            <div
                              key={option}
                              className={`custom-dropdown-option ${formData.language === option ? "selected" : ""}`}
                              onClick={() => {
                                setFormData({ ...formData, language: option });
                                setErrors({ ...errors, language: "" });
                                setOpenDropdown(null);
                              }}
                            >
                              {option}
                              {formData.language === option && <span className="custom-check">✓</span>}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {errors.language && <p className="admin-error">{errors.language}</p>}

                    {/* SUBMIT */}
                    <button
                      className="admin-submit-btn mt-4"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Supportpage;